import React from 'react';

import { Box, Typography } from '@mui/material';

import Mockup from './mockup';

export const HowItWorks = () => {
  return (
    <Box
      mx="auto"
      style={{
        maxWidth: '60ch',
      }}
    >
      <Typography variant="h2" align="center">
        Jak działa nasz kurs?
      </Typography>
      <Box>
        <Box>
          <Typography variant="body1" paragraph={true}>
            Dzięki naszemu kursowi zrozumiesz matematykę oraz nadrobisz
            zaległości.
          </Typography>
          <Box display="flex" alignItems="center">
            <Box
              mr={{
                xs: 1,
                sm: 2,
                md: 3,
                lg: 4,
              }}
            >
              <Mockup
                fileName="wszystkie-działy-matematyczne"
                alt="Wszystkie działy matematyczne w aplikacji matematyka gryzie."
              />
            </Box>
            <Typography variant="body1" paragraph={true}>
              Wystarczy wybrać odpowiedni dział (poukładane są one według
              częstotliwości występowania na egzaminie).
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Typography variant="body1" paragraph={true}>
              Wyświetli się zadanie. Bierzesz kartkę i długopis, rozwiązujesz a
              następnie sprawdzasz swoją odpowiedź.
            </Typography>
            <Box
              ml={{
                xs: 1,
                sm: 2,
                md: 3,
                lg: 4,
              }}
            >
              <Mockup
                fileName="rozwiązywanie-zadań-w-aplikacji"
                alt="Rozwiązywanie zadań matematematycznych w aplikacji matematyka gryzie."
              />
            </Box>
          </Box>

          <Box display="flex" alignItems="center">
            <Box
              mr={{
                xs: 1,
                sm: 2,
                md: 3,
                lg: 4,
              }}
            >
              <Mockup
                fileName="objerzyj-rozwiązanie-zadania-matematycznego"
                alt="Obejrzyj rozwiązanie zadania matematycznego"
              />
            </Box>
            <Typography variant="body1" paragraph={true}>
              Jeśli chcesz poznać sposób rozwiązania na filmiku znajdującym się
              pod zadaniem możesz dokładnie zrozumieć popełnione błędy lub też
              nauczyć się danego zagadnienia od zera.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HowItWorks;
